import { Box } from "@mui/material";
import { CSSProperties, useId } from "react";
import appColors from "../../app/appColors";

/** Simsiyah kontur kalinligi (px). Blursuz; tek SVG filtresi. */
const STROKE_OUTLINE_PX = 3;

interface IPdfPreviewOverlayBoxProps {
    baseImageUri: string;
    overlayImageUri?: string;
    width?: number;
}

const PdfPreviewOverlayBox = (props: IPdfPreviewOverlayBoxProps) => {
    const width = props.width ?? 110;
    const hasOverlay = !!props.overlayImageUri;
    const filterId = `pdf-preview-stroke-${useId().replace(/:/g, "")}`;

    const overlayStyle: CSSProperties = {
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        objectFit: "contain",
        pointerEvents: "none",
        mixBlendMode: "normal",
        opacity: 1,
        // feMorphology (dilate) + renk canlandirma; coklu drop-shadow yerine (Chrome icin hafif)
        filter: hasOverlay
            ? `url(#${filterId}) contrast(1.25) saturate(1.6) brightness(1.08)`
            : undefined,
    };

    return <Box style={{ width, position: "relative", background: appColors.GRAY_LIGHT2, border: "1px solid #bdbdbd" }}>
        {!hasOverlay ? null : <svg aria-hidden style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}>
            <defs>
                {/*
                  feMorphology dilate: alpha kanalini radius kadar genisletir (blur yok, piksel konturu).
                  feFlood + feComposite: genisleyen alani simsiyah doldurur.
                  feMerge: once siyah kontur, ustte orijinal boyali PNG.
                  Kalinlik: STROKE_OUTLINE_PX

                  drop-shadow(offset-x offset-y blur-radius color) — cok kopya Chrome'u zorlar;
                  blur-radius > 0 yumusak kenar, 0 + cok offset = kalin ama pahali kontur.
                */}
                <filter
                    id={filterId}
                    x="-30%"
                    y="-30%"
                    width="160%"
                    height="160%"
                    colorInterpolationFilters="sRGB">
                    <feMorphology
                        in="SourceAlpha"
                        operator="dilate"
                        radius={STROKE_OUTLINE_PX}
                        result="dilated" />
                    <feFlood floodColor="#000" floodOpacity="1" result="black" />
                    <feComposite in="black" in2="dilated" operator="in" result="outline" />
                    <feMerge>
                        <feMergeNode in="outline" />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
            </defs>
        </svg>}
        <img
            alt={""}
            title={""}
            src={props.baseImageUri}
            style={{ width: "100%", display: "block", background: appColors.WHITE }} />
        {!hasOverlay ? null : <img
            alt={""}
            title={""}
            src={props.overlayImageUri}
            style={overlayStyle} />}
    </Box>;
};

export default PdfPreviewOverlayBox;
